var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-select',{staticClass:"pt-0",attrs:{"items":_vm.items,"value":_vm.value,"hide-details":"","single-line":"","dense":""},on:{"change":function($event){_vm.$emit('input', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }